import { __extends } from "tslib";
import { DeprecatedButton, DeprecatedDangerButton, DeprecatedHollowButton } from '../../primitives/deprecated-buttons';
import { Modal, ModalBody, ModalSize, ModalFooter } from '../../primitives/modal';
import * as React from 'react';
import { namespacedClassnames } from '../../common';
import { Checkbox } from '../../primitives';
import { Text } from '../../new-libby';
export var confirmModalKey = 'confirm-modal';
var ConfirmModal = /** @class */ (function (_super) {
    __extends(ConfirmModal, _super);
    function ConfirmModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            confirmCheckboxValue: !!_this.props.checkboxText ? false : true,
        };
        _this.toggleCheckboxValue = function (confirmCheckboxValue) { return _this.setState({ confirmCheckboxValue: confirmCheckboxValue }); };
        return _this;
    }
    ConfirmModal.prototype.render = function () {
        var props = this.props;
        var className = namespacedClassnames(confirmModalKey, props.className);
        var isOpen = props.isOpen, title = props.title, body = props.body, confirmText = props.confirmText, cancelText = props.cancelText, onConfirm = props.onConfirm, onCancel = props.onCancel, level = props.level, disableConfirm = props.disableConfirm, checkboxText = props.checkboxText;
        var maybeDisableConfirm = !!checkboxText ? (this.state.confirmCheckboxValue ? undefined : disableConfirm || true) : disableConfirm;
        var renderConfirmButton = function () {
            switch (level) {
                case 'confirm':
                    return (React.createElement(DeprecatedButton, { className: namespacedClassnames('confirm'), onClick: onConfirm, disabled: maybeDisableConfirm }, confirmText));
                case 'alert':
                    return (React.createElement(DeprecatedDangerButton, { className: namespacedClassnames('confirm'), onClick: onConfirm, disabled: maybeDisableConfirm }, confirmText));
                default:
                    return (React.createElement(DeprecatedDangerButton, { className: namespacedClassnames('confirm'), onClick: onConfirm, disabled: maybeDisableConfirm }, confirmText));
            }
        };
        var maybeCheckbox = !!checkboxText ? (React.createElement("div", { className: 'confirm-modal-checkbox' },
            React.createElement(Checkbox, { onChange: this.toggleCheckboxValue, value: this.state.confirmCheckboxValue },
                React.createElement(Text, { type: 't', color: 't20' }, checkboxText)))) : null;
        return (React.createElement(Modal, { className: className, isOpen: isOpen, size: ModalSize.SMALL, usePortal: props.usePortal },
            React.createElement(ModalBody, null,
                React.createElement(Text, { className: 'title', type: 'hnm' }, title),
                React.createElement("div", { className: namespacedClassnames('body') }, body),
                maybeCheckbox),
            React.createElement(ModalFooter, null,
                React.createElement(DeprecatedHollowButton, { className: namespacedClassnames('cancel'), onClick: onCancel }, cancelText),
                renderConfirmButton())));
    };
    return ConfirmModal;
}(React.Component));
export { ConfirmModal };
//# sourceMappingURL=confirm-modal.comp.js.map